import { createFileRoute } from '@tanstack/react-router'
import { PayrollRunDetailPage } from '@/features/payroll/ui/PayrollRunDetailPage'
import { PayrollAccessDenied } from '@/features/payroll/ui/PayrollAccessDenied'
import { PermissionGuard } from '@/shared/components/PermissionGuard'
import { PERMISSIONS } from '@/shared/config/permissions'

export const Route = createFileRoute('/payroll/runs/$runId/')({
  component: RunDetailRoute,
  staticData: { authorize: true },
})

function RunDetailRoute() {
  const { runId } = Route.useParams()
  return (
    <PermissionGuard
      permission={PERMISSIONS.PayrollView}
      fallback={<PayrollAccessDenied />}
    >
      <PayrollRunDetailPage runId={Number(runId)} />
    </PermissionGuard>
  )
}
